<div class="dialog">
  <h1 mat-dialog-title>{{ 'dialog_check_scenario_title' | translate }}</h1>
  <h3>{{ 'dialog_check_scenario_legend' | translate }}</h3>

  <p [innerHTML]="'dialog_check_scenario_legend_yellow' | translate"></p>

  <p [innerHTML]="'dialog_check_scenario_legend_green' | translate"></p>

  <p [innerHTML]="'dialog_check_scenario_legend_blue' | translate"></p>

  <p [innerHTML]="'dialog_check_scenario_legend_red' | translate"></p>

  <mat-divider></mat-divider>

  <div *ngFor="let solution of data.scenario.solutions">
    <h2>{{ solution.displayName }}</h2>
    <p>
      <span class="yellow"> {{ solution.description }} </span>
    </p>

    <div *ngFor="let operation of solution.operations">
      <h3>{{ operation.displayName }}</h3>

      <!-- Table : Produits entrants -->
      <table *ngIf="operation.detailedOperation.inputProducts.length > 0" mat-table [dataSource]="operation.detailedOperation.inputProducts" class="mat-elevation-z8" aria-describedby="inputProducts">
        <!-- Colonne : Matériaux entrants -->
        <ng-container matColumnDef="Matériaux entrants">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_input_materials' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.displayName }}</span>
            <p class="display-transport" *ngIf="element.pipeProduct == 1">
              <span>{{ 'dialog_check_scenario_dn_mm' | translate }} {{ element.diameter }}</span>
              <br />
              <span>{{ 'dialog_check_scenario_unit_weight_ml' | translate }} {{ element.unitWeight }}</span>
            </p>
            <p class="display-transport" *ngIf="element.pipeProduct == 2">
              <span>{{ 'dialog_check_scenario_dn_mm' | translate }} {{ element.diameter }}</span>
              <br />
              <span>{{ 'dialog_check_scenario_unit_weight_unit' | translate }} {{ element.unitWeight }}</span>
            </p>
            <p class="display-transport" *ngIf="element.cableProduct">
              <span>{{ 'dialog_check_scenario_section_mm2' | translate }} {{ element.section }}</span>
              <br />
              <span>{{ 'dialog_check_scenario_nb_conductors' | translate }} {{ element.nbConductors }}</span>
            </p>
          </td>
        </ng-container>

        <!-- Colonne : Quantité -->
        <ng-container matColumnDef="Quantité">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_quantity' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.quantity }}</span>
          </td>
        </ng-container>

        <!-- Colonne : Unité d'oeuvre -->
        <ng-container matColumnDef="Unité d'oeuvre">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_work_unit' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.shortWorkUnit }}</span>
          </td>
        </ng-container>

        <!-- Colonne : Densité -->
        <ng-container matColumnDef="Densité">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_density' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.shortWorkUnit != 't' && element.density; else tonne">
              <span>{{ element.density }}</span>
              <br />
              <span>t/{{ element.shortWorkUnit }}</span>
            </ng-container>
            <ng-template #tonne>
              <span>-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Colonne : Coût environnemental unitaire -->
        <ng-container matColumnDef="Coût environnemental unitaire">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_unit_env_cost' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container [ngTemplateOutlet]="element.detailedResource ? formula : element.ruade ? ruade : element.justified ? justified : notJustified"> </ng-container>
            <ng-template #formula>
              <span>{{ 'dialog_check_scenario_see_formulas' | translate }}</span>
            </ng-template>
            <ng-template #ruade>
              <span class="green">{{ 'dialog_check_scenario_usirf_base' | translate: { name: element.displayName } }}</span>
            </ng-template>
            <ng-template #justified>
              <span class="blue">{{ 'dialog_check_scenario_proof_attached' | translate }}</span>
            </ng-template>
            <ng-template #notJustified>
              <span class="red">{{ 'dialog_check_scenario_no_proof' | translate }}</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Colonne : Acheminement -->
        <ng-container matColumnDef="Acheminement">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_routing' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container [ngTemplateOutlet]="!element.transportId || (element.isMultimodal && element.journeys?.length == 0) ? emptyTransport : !element.isMultimodal && element.distance ? transport : acheminement"> </ng-container>
            <ng-template #emptyTransport>
              <span>-</span>
            </ng-template>
            <ng-template #transport>
              <p class="display-transport">
                <span>{{ element.transportName }} : {{ element.distance }}km</span><br />
                <span *ngIf="element.isDoubleFreight">{{ 'dialog_check_scenario_double_freight' | translate }}</span>
              </p>
            </ng-template>
            <ng-template #acheminement>
              <ng-container *ngFor="let journey of element.journeys">
                <p class="display-transport">
                  <span> {{ journey.transportDisplayName }} : {{ journey.distance }}km</span>
                </p>
              </ng-container>
            </ng-template>
            <p class="display-transport" *ngIf="element.pipeProduct">{{ 'dialog_check_scenario_production_site' | translate }} {{ element.productionSite }}</p>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsInputProducts"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsInputProducts"></tr>
      </table>

      <!-- Table : Engins -->
      <table *ngIf="operation.detailedOperation.vehicles.length > 0" mat-table [dataSource]="operation.detailedOperation.vehicles" class="mat-elevation-z8" aria-describedby="vehicles">
        <!-- Colonne : Engins -->
        <ng-container matColumnDef="Engins">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_engines' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
        </ng-container>

        <!-- Colonne : Quantité -->
        <ng-container matColumnDef="Quantité">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_quantity' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
        </ng-container>

        <!-- Colonne : Coût environnemental unitaire -->
        <ng-container matColumnDef="Coût environnemental unitaire">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_unit_env_cost' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container [ngTemplateOutlet]="element.isAtelier ? atelier : element.ruade ? ruade : element.justified ? justified : notJustified"> </ng-container>
            <ng-template #atelier>
              <span>-</span>
            </ng-template>
            <ng-template #ruade>
              <span class="green">{{ 'dialog_check_scenario_usirf_base' | translate: { name: element.displayName } }}</span>
            </ng-template>
            <ng-template #justified>
              <span class="blue">{{ 'dialog_check_scenario_proof_attached' | translate }}</span>
            </ng-template>
            <ng-template #notJustified>
              <span class="red">{{ 'dialog_check_scenario_no_proof' | translate }}</span>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsVehicles"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsVehicles"></tr>
      </table>

      <!-- Table : Dragues -->
      <table *ngIf="operation.detailedOperation.dredging?.length > 0" mat-table [dataSource]="operation.detailedOperation.dredging" class="mat-elevation-z8" aria-describedby="dredging">
        <ng-container matColumnDef="Drague">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common_field_dredging' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
        </ng-container>

        <ng-container matColumnDef="Durée">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common_field_duration' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.execPhaseDuration }} {{ 'common_unit_weeks' | translate }}</td>
        </ng-container>

        <ng-container matColumnDef="Coût environnemental unitaire">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_unit_env_cost' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.fileName; else notJustifiedDredging" class="blue">{{ 'dialog_check_scenario_proof_attached' | translate }}</span>
            <ng-template #notJustifiedDredging>
              <span class="red">{{ 'dialog_check_scenario_no_proof' | translate }}</span>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsDredging"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsDredging"></tr>
      </table>

      <!-- Table : Tunneliers -->
      <table *ngIf="operation.detailedOperation.tunneling?.length > 0" mat-table [dataSource]="operation.detailedOperation.tunneling" class="mat-elevation-z8" aria-describedby="tunneling">
        <ng-container matColumnDef="Tunnelier">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common_field_tunneling' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
        </ng-container>

        <ng-container matColumnDef="Énergie">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common_field_energy' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.energyName || ('common_no_energy' | translate) }}</td>
        </ng-container>

        <ng-container matColumnDef="Durée">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common_field_duration' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.presenceDuration }} {{ 'common_unit_days' | translate }}</td>
        </ng-container>

        <ng-container matColumnDef="Coût environnemental unitaire">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_unit_env_cost' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.fileName; else notJustifiedTunneling" class="blue">{{ 'dialog_check_scenario_proof_attached' | translate }}</span>
            <ng-template #notJustifiedTunneling>
              <span class="red">{{ 'dialog_check_scenario_no_proof' | translate }}</span>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsTunneling"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsTunneling"></tr>
      </table>

      <!-- Table : Produits sortants -->
      <table *ngIf="operation.detailedOperation.outputProducts.length > 0" mat-table [dataSource]="operation.detailedOperation.outputProducts" class="mat-elevation-z8" aria-describedby="outputProducts">
        <!-- Colonne : Matériaux sortants -->
        <ng-container matColumnDef="Matériaux sortants">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_output_materials' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
        </ng-container>

        <!-- Colonne : Quantité -->
        <ng-container matColumnDef="Quantité">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_quantity' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.quantity }}</span>
          </td>
        </ng-container>

        <!-- Colonne : Unité d'oeuvre -->
        <ng-container matColumnDef="Unité d'oeuvre">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_work_unit' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.shortWorkUnit }}</span>
          </td>
        </ng-container>

        <!-- Colonne : Densité -->
        <ng-container matColumnDef="Densité">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_density' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.shortWorkUnit != 't' && element.density; else tonne">
              <span>{{ element.density }}</span>
              <br />
              <span>t/{{ element.shortWorkUnit }}</span>
            </ng-container>
            <ng-template #tonne>
              <span>-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Colonne : Coût environnemental unitaire -->
        <ng-container matColumnDef="Coût environnemental unitaire">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_unit_env_cost' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container [ngTemplateOutlet]="element.detailedResource ? formula : element.ruade ? ruade : element.justified ? justified : notJustified"> </ng-container>
            <ng-template #formula>
              <span>{{ 'dialog_check_scenario_see_formulas' | translate }}</span>
            </ng-template>
            <ng-template #ruade>
              <span class="green">{{ 'dialog_check_scenario_usirf_base' | translate: { name: element.displayName } }}</span>
            </ng-template>
            <ng-template #justified>
              <span class="blue">{{ 'dialog_check_scenario_proof_attached' | translate }}</span>
            </ng-template>
            <ng-template #notJustified>
              <span class="red">{{ 'dialog_check_scenario_no_proof' | translate }}</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Colonne : Acheminement -->
        <ng-container matColumnDef="Acheminement">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'dialog_check_scenario_col_routing' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <ng-container [ngTemplateOutlet]="!element.transportId ? emptyTransport : !element.isMultimodal && element.distance ? transport : acheminement"> </ng-container>
            <ng-template #emptyTransport>
              <span>-</span>
            </ng-template>
            <ng-template #transport>
              <p class="display-transport">
                <span>{{ element.transportName }} : {{ element.distance }}km</span><br />
                <span *ngIf="element.isDoubleFreight">{{ 'dialog_check_scenario_double_freight' | translate }}</span>
              </p>
            </ng-template>
            <ng-template #acheminement>
              <ng-container *ngFor="let journey of element.journeys">
                <p class="display-transport">
                  <span> {{ journey.transportDisplayName }} : {{ journey.distance }}km</span>
                </p>
              </ng-container>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsOutputProducts"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsOutputProducts"></tr>
      </table>
    </div>

    <mat-divider></mat-divider>
  </div>

  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_back' | translate }}</button>
    <button mat-button (click)="exportExcel(data.scenario)" color="accent">{{ 'action_bar_export_excel' | translate }}</button>
  </div>
</div>
